import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  LateInitSignal30crwrg540xyy as LateInitSignal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Key_instance6wd16m35aua5 as Key_instance } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/RView.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { getOrNull1go7ef9ldk0df as getOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CellClass;
function Cell() {
  if (CellClass === VOID) {
    class $ {
      static dgf(container, rendererSet, data, id, renderer, index) {
        var $this = createThis(this);
        $this.wge_1 = rendererSet;
        $this.xge_1 = data;
        $this.yge_1 = id;
        $this.zge_1 = renderer;
        $this.agf_1 = _Constant___init__impl__v45mub(index);
        var tmp = $this;
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(container.pc());
        var tmp0_elvis_lhs = container.ebb_1;
        var p = tmp0_elvis_lhs == null ? container : tmp0_elvis_lhs;
        container.gbb(p, view);
        renderer.pdg(view, $this.xge_1, new (Constant())($this.agf_1));
        container.hbb(p, view);
        tmp.bgf_1 = view;
        $this.cgf_1 = false;
        return $this;
      }
      static egf(container, set, data, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = LateInitSignal().taq();
        set_value(this_0, data);
        return this.dgf(container, set, this_0, set.kdg(data), set.jdg(data), index);
      }
      eah(readable) {
        if (this.cgf_1)
          return Unit_instance;
        this.cgf_1 = true;
        var tmp0_safe_receiver = this.bgf_1.ga2().cd(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.eah(readable);
        }
      }
      jdc() {
        // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
        var tmp = this.bgf_1.vb5_1.xb3_1;
        var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
          var this_0 = tmp0_safe_receiver;
          var animate = get_animationsEnabled();
          try {
            if (animate) {
              set_animationsEnabled(false);
              // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
              // Inline function 'kotlin.js.asDynamic' call
              var tmp_1 = this_0.__suppressMutationObserverClass;
              var tmp0_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
              var tmp_2;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var n = ArrayList().w();
                // Inline function 'kotlin.js.asDynamic' call
                this_0.__suppressMutationObserverClass = n;
                tmp_2 = n;
              } else {
                tmp_2 = tmp0_elvis_lhs;
              }
              var e = tmp_2;
              this_0.classList.add('notransition');
              var tmp1_elvis_lhs = this_0.getAttribute('class');
              e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
            }
            this.bgf_1.jb7(false);
          }finally {
            if (animate) {
              var tmp_3 = window;
              tmp_3.setTimeout(() => {
                // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                var this_1 = this_0;
                // Inline function 'kotlin.js.asDynamic' call
                var tmp = this_1.__suppressMutationObserverClass;
                var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
                var tmp_0;
                if (tmp0_elvis_lhs == null) {
                  // Inline function 'kotlin.run' call
                  var n = ArrayList().w();
                  // Inline function 'kotlin.js.asDynamic' call
                  this_1.__suppressMutationObserverClass = n;
                  tmp_0 = n;
                } else {
                  tmp_0 = tmp0_elvis_lhs;
                }
                var e = tmp_0;
                this_0.classList.remove('notransition');
                var tmp1_elvis_lhs = this_1.getAttribute('class');
                e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                return Unit_instance;
              }, 100);
              set_animationsEnabled(true);
            }
          }
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this.bgf_1.jb7(false);
        }
      }
      fgf(value) {
        this.bgf_1.dba(true);
        if (equals(this.wge_1.kdg(value), this.yge_1)) {
          set_value(this.xge_1, value);
        } else {
          var r = this.wge_1.jdg(value);
          if (r === this.zge_1 || equals(r, this.zge_1)) {
            set_value(this.xge_1, value);
          } else {
            this.zge_1 = r;
            // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
            var tmp = this.bgf_1.vb5_1.xb3_1;
            var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
              var this_0 = tmp0_safe_receiver;
              var animate = get_animationsEnabled();
              try {
                if (animate) {
                  set_animationsEnabled(false);
                  // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp_1 = this_0.__suppressMutationObserverClass;
                  var tmp0_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
                  var tmp_2;
                  if (tmp0_elvis_lhs == null) {
                    // Inline function 'kotlin.run' call
                    var n = ArrayList().w();
                    // Inline function 'kotlin.js.asDynamic' call
                    this_0.__suppressMutationObserverClass = n;
                    tmp_2 = n;
                  } else {
                    tmp_2 = tmp0_elvis_lhs;
                  }
                  var e = tmp_2;
                  this_0.classList.add('notransition');
                  var tmp1_elvis_lhs = this_0.getAttribute('class');
                  e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                }
                this.bgf_1.bba();
                set_value(this.xge_1, value);
                r.pdg(this.bgf_1, this.xge_1, new (Constant())(this.agf_1));
              }finally {
                if (animate) {
                  var tmp_3 = window;
                  tmp_3.setTimeout(() => {
                    // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                    var this_1 = this_0;
                    // Inline function 'kotlin.js.asDynamic' call
                    var tmp = this_1.__suppressMutationObserverClass;
                    var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
                    var tmp_0;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'kotlin.run' call
                      var n = ArrayList().w();
                      // Inline function 'kotlin.js.asDynamic' call
                      this_1.__suppressMutationObserverClass = n;
                      tmp_0 = n;
                    } else {
                      tmp_0 = tmp0_elvis_lhs;
                    }
                    var e = tmp_0;
                    this_0.classList.remove('notransition');
                    var tmp1_elvis_lhs = this_1.getAttribute('class');
                    e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                    return Unit_instance;
                  }, 100);
                  set_animationsEnabled(true);
                }
              }
              tmp_0 = Unit_instance;
            }
            if (tmp_0 == null) {
              this.bgf_1.bba();
              set_value(this.xge_1, value);
              r.pdg(this.bgf_1, this.xge_1, new (Constant())(this.agf_1));
            }
          }
        }
      }
    }
    initMetadataForClass($, 'Cell');
    CellClass = $;
  }
  return CellClass;
}
function forEachWithRenderer(_this__u8e3s4, items, rendererSet, loadingRenderers) {
  loadingRenderers = loadingRenderers === VOID ? emptyList() : loadingRenderers;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(loadingRenderers, 10));
  var index = 0;
  var _iterator__ex2g4s = loadingRenderers.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var idx = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$0 = Cell().dgf(_this__u8e3s4, rendererSet, LateInitSignal().taq(), null, item, idx);
    destination.v(tmp$ret$0);
  }
  var currentViews = ArrayList().b1(destination);
  reactive(_this__u8e3s4, ($this$reactive) => {
    var list = $this$reactive.daj(items);
    var iterator = list.m1();
    var index = 0;
    while (iterator.n1()) {
      var idx = index;
      index = index + 1 | 0;
      var item = iterator.o1();
      var tmp0_safe_receiver = getOrNull(currentViews, idx);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver.fgf(item);
        tmp = Unit_instance;
      }
      if (tmp == null)
        currentViews.v(Cell().egf(_this__u8e3s4, rendererSet, item, idx));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = currentViews.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      element.eah($this$reactive);
    }
    var tmp_0;
    if (currentViews.p1() > list.p1()) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = currentViews.m3(list.p1(), currentViews.p1()).m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        element_0.jdc();
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  });
}
//region block: exports
export {
  forEachWithRenderer as forEachWithRenderer12ybmdeyp3omm,
};
//endregion

//# sourceMappingURL=forEachWithRenderer.mjs.map
